var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGateicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.886,
    height: 22.189,
    viewBox: "0 0 23.886 22.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-3.904 -3.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170487",
    "data-name": "Path 170487",
    d: "M48.465,38.259H40.1V57.665h8.365C48.465,49.227,48.461,38.269,48.465,38.259Zm-2.5,11.08c-.444.008-.889.007-1.333.006H43.423c.041.043.077.083.114.125a.621.621,0,0,1,.007.89.607.607,0,0,1-.43.187.683.683,0,0,1-.462-.2c-.4-.383-.8-.782-1.2-1.187a.621.621,0,0,1,.014-.894c.429-.435.814-.816,1.174-1.164a.632.632,0,0,1,.893-.036.624.624,0,0,1-.016.919,1.038,1.038,0,0,1-.119.107H45.74c.076,0,.153,0,.229,0a.633.633,0,0,1,.644.62.626.626,0,0,1-.643.626Z",
    transform: "translate(-33.249 -31.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170489",
    "data-name": "Path 170489",
    d: "M34.015,11.85H13.771a1.67,1.67,0,0,0-1.821,1.812V34.039h1.678v-19.8c0-.7.183-.878.892-.878h1.536c2.16,0,13.628,0,15.833,0h1.529c.751,0,.923.171.923.911V34.031h1.494V13.662a1.67,1.67,0,0,0-1.822-1.812Z",
    transform: "translate(-8.046 -7.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171337",
    "data-name": "Path 171337",
    d: "M40.1,38.259h8.365V57.665H40.1C40.1,49.227,40.1,38.269,40.1,38.259Zm2.5,11.08c.444.008.889.007,1.333.006h1.214c-.041.043-.077.083-.114.125a.621.621,0,0,0-.007.89.607.607,0,0,0,.43.187.683.683,0,0,0,.462-.2c.4-.383.8-.782,1.2-1.187a.621.621,0,0,0-.014-.894c-.429-.435-.814-.816-1.174-1.164a.632.632,0,0,0-.893-.036.624.624,0,0,0,.016.919,1.038,1.038,0,0,0,.119.107H42.824c-.076,0-.153,0-.229,0a.633.633,0,0,0-.644.62.626.626,0,0,0,.643.626Z",
    transform: "translate(-23.313 -31.62)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateicon);
export default __webpack_public_path__ + "static/media/gateicon.530c1dc92feed7792483ad70443c45bd.svg";
export { ForwardRef as ReactComponent };